// extracted by mini-css-extract-plugin
export default {"activeClass":"Select_activeClass__GKcYy","selectCl":"Select_selectCl__R79vi","optionCl":"Select_optionCl__Dgx3B","usual":"Select_usual__AMBBs","lastDiv":"Select_lastDiv__Rlq89"};